import qs from 'query-string';

import appSettings from 'wanderu-config';
import {
    selectLocale,
} from 'wanderu-i18n';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';
import { OrdersService } from 'wanderu-service-wapi';

import { POLL_STATUS_DELAY_MS } from '../../../constants';
import {
    actions as bookingActions,
    selectors as bookingSelectors,
} from '../../appstate';
import { selectors as ordersSelectors } from '../../ordersSlice';
import { pollEndpoint } from '../utils';
import {
    actions,
    namespace,
    reducer,
    selectors,
} from './base';

const logger = Logger.getLogger('wanderu-app-booking:pollBookingStatus');

function pollBookingStatus(processingId) {
    return async (dispatch, getState) => {
        dispatch(actions.startWork(processingId));

        let error;
        let meta;
        try {
            const locale = selectLocale(getState());
            const {
                itineraryId,
                bookingSessionId,
            } = bookingSelectors.selectBookingInfo(getState());

            // orderId should already be set by fetchFormAndSummary, but may be
            // undefined if that call failed. Read once outside the poll loop.
            const orderId = ordersSelectors.selectOrderId(getState());

            if (!orderId) {
                logger.warn('missingOrderId', { bookingSessionId, itineraryId });
            }

            const queries = {
                booking_session_id: bookingSessionId,
                itinerary_id: itineraryId,
                locale,
                orderId,
                processing_id: processingId,
            };

            const fetchFn = async () => {
                const url = `wtix/v4/book/status?${qs.stringify(queries)}`;

                const response = await OrdersService.get(url);
                const statusData = response.result || response.error;

                dispatch(bookingActions.setBookingStatus(processingId, statusData));
            };

            const shouldContinue = () => {
                const status = bookingSelectors.selectBookingStatus(getState(), processingId);
                return status.isQueued || status.isProcessing;
            };

            await pollEndpoint(fetchFn, shouldContinue, POLL_STATUS_DELAY_MS);
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            error = ex?.responseBody?.error;

            // Set booking status from error so UI can show error state
            if (error) {
                dispatch(bookingActions.setBookingStatus(processingId, error));
            }

            logger.error('pollBookingStatus', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });

            throw ex;
        } finally {
            dispatch(actions.endWork(processingId, meta, error));
        }
    };
}

const pollBookingStatusAction = {
    poll: pollBookingStatus,
    ...selectors,
    ...actions,
};

export {
    pollBookingStatusAction,
};

export default {
    [namespace]: reducer,
};
